import type { RoleEnum } from '@zeus/index'
import { useQuery } from '@apollo/client/react'
import { useEffect } from 'react'
import { GQL_ME } from '~/gql/auth/auth'
import { getDefaultRoute } from '~/routes/protected-loader'

/**
 * Un visiteur déjà connecté n'a pas à nommer son organisation (#346) : on le
 * renvoie sur l'accueil de son rôle, dans son espace. Vrai tant que la
 * vérification est en cours ou que le départ est lancé, pour ne pas lui montrer
 * le formulaire une fraction de seconde.
 */
export function useSignedInHome(): boolean {
  const { data, loading } = useQuery(GQL_ME, { fetchPolicy: 'network-only' })
  const me = data?.me
  const home = me?.orgSlug ? `/o/${me.orgSlug}${getDefaultRoute(me.roles as RoleEnum)}` : null

  useEffect(() => {
    if (home) window.location.replace(home)
  }, [home])

  return loading || !!home
}
